"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _fund_document_list = require("./fund_document_list");

var _fund_document_list2 = _interopRequireDefault(_fund_document_list);

var _functional_utility = require("common-utilities/src/functional_utility");

var _ramda = require("ramda");

var _constants = require("common-utilities/src/constants");

var _constants2 = _interopRequireDefault(_constants);

var _reactWaypoint = require("react-waypoint");

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _string_utility = require("common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SecurityLendingOverviewCard = function (_React$Component) {
  _inherits(SecurityLendingOverviewCard, _React$Component);

  function SecurityLendingOverviewCard(props) {
    _classCallCheck(this, SecurityLendingOverviewCard);

    return _possibleConstructorReturn(this, (SecurityLendingOverviewCard.__proto__ || Object.getPrototypeOf(SecurityLendingOverviewCard)).call(this, props));
  }

  _createClass(SecurityLendingOverviewCard, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          pdpCardSecuritiesLending = _props.pdpCardSecuritiesLending,
          pdpCardSecuritiesLendingFeeSplit = _props.pdpCardSecuritiesLendingFeeSplit;

      if ((0, _functional_utility.isNilOrEmpty)(pdpCardSecuritiesLending) && (0, _functional_utility.isNilOrEmpty)(pdpCardSecuritiesLendingFeeSplit)) {
        return null;
      }
      var contentId = this.props.id + '-content';
      return _react2.default.createElement(
        "div",
        { className: this.props.componentId + "-child-card" },
        this.props.activeCardHandler ? _react2.default.createElement(_reactWaypoint2.default, { topOffset: "35%", bottomOffset: "80%",
          onEnter: this.props.activeCardHandler.bind(this, this.props.id) }) : null,
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: this.props.headerLabel,
            headerTitleId: this.props.id,
            headerTitleLabel: 'securities-lending-child-header',
            breakpoint: this.props.breakpoint,
            disclosureText: this.props.disclosureText,
            placementId: this.props.dataTest
          },
          _react2.default.createElement(
            "div",
            { "data-testid": contentId, id: contentId },
            _react2.default.createElement(
              "span",
              { className: "font-16 text-middle line-height-22 margin-bottom-10", "data-testid": contentId + "-disclosure" },
              _react2.default.createElement(
                "p",
                null,
                " ",
                pdpCardSecuritiesLending,
                " "
              )
            ),
            pdpCardSecuritiesLendingFeeSplit ? this.renderContent(contentId) : null,
            _react2.default.createElement(
              "span",
              { className: "font-16 text-middle line-height-22 margin-bottom-10" },
              this.renderDocuments()
            )
          )
        )
      );
    }
  }, {
    key: "renderContent",
    value: function renderContent(contentId) {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "font-16 font-regular margin-bottom-8", "data-testid": contentId + "-fee-split" },
          " ",
          _string_utility2.default.renderFormattedLabel("Fee Split", "pdp-securities-lending-data-fee-split"),
          " "
        ),
        _react2.default.createElement(
          "span",
          { className: "font-16 text-middle line-height-22 margin-bottom-10", "data-testid": contentId + "-fee-split-disclosure" },
          _react2.default.createElement(
            "p",
            null,
            " ",
            this.props.pdpCardSecuritiesLendingFeeSplit,
            " "
          )
        )
      );
    }
  }, {
    key: "renderDocuments",
    value: function renderDocuments() {
      var content = this.props.content;
      var TAG = _constants2.default.getFdTagConstants();
      var cusip = (0, _ramda.toUpper)(this.props.cusip);
      var securitiesLendingDocs = [{ documentType: TAG.HK_FUND_INFORMATION_CHINESE }, { documentType: TAG.SECURITY_LENDING_POLICY }, { documentType: TAG.LUX_COMMUNICATION }];
      var dataArr = !(0, _functional_utility.isNilOrEmpty)(content) && (0, _functional_utility.isObjectAndHasProp)(content.documents, cusip) ? content.documents[cusip] : [];
      var documents = [];

      var _loop = function _loop(i) {
        documents.push((0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
          return x === securitiesLendingDocs[i].documentType;
        }, 'documentType'), dataArr));
      };

      for (var i = 0; i < securitiesLendingDocs.length; i++) {
        _loop(i);
      }
      documents = (0, _ramda.flatten)(documents);
      if (!(0, _functional_utility.isNilOrEmpty)(documents)) {
        return _react2.default.createElement(
          "div",
          { "data-testid": this.props.dataTest },
          _react2.default.createElement(_fund_document_list2.default, { documents: documents,
            userLoggedIn: this.props.userLoggedIn,
            headerTitleId: this.props.headerTitleId,
            role: this.props.role,
            basePath: this.props.basePath,
            window: this.props.window,
            defaultStyle: "tag",
            textColorClass: "font-teal",
            showDownloadIcon: false,
            noOfColumns: 1,
            isDocumentTabCard: false
          })
        );
      }
    }
  }]);

  return SecurityLendingOverviewCard;
}(_react2.default.Component);

exports.default = SecurityLendingOverviewCard;